<template>
  <v-container fluid grid-list-lg>

    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList"
      :editZakatAllocation="selectedZakatAllocation"></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle title="Zakat Allocation" :access="checkRightStatus(77)" @add="add" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
            hide-details clearable></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="zakatAllocations" :search="search" :loading="loading" :sort-by="sortBy"
          :page.sync="page" :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <!-- <td class="text-left">{{ item.createdAt | moment('MM/DD/YYYY') }}</td> -->
              <td class="text-left">
                <span v-html="highlightDate(item.startDate)"></span>
                <!-- <span>{{ item.startDate | moment("MM/DD/YYYY") }}</span> -->
              </td>

              <td class="text-left">
                <span v-html="$options.filters.highlight(item.Customer.name, search.toLowerCase())"
                  v-if="item.Customer">{{
                  item.Customer.name}}</span>
              </td>

              <td class="text-left">
                <span v-html="$options.filters.highlight(item.Student.fullName, search.toLowerCase())"
                  v-if="item.Student">{{
                  item.Student.fullName}}</span>
              </td>

              <td class="text-left">
                <span>{{ item.endDate | moment("MM/DD/YYYY") }}</span>
              </td>

              <td class="text-right">
                <span v-html="highlightAmount(item.amount)"></span>
                <!-- <span v-html="$options.filters.highlight(item.amount, search.toLowerCase())">{{
                  item.amount | currency }}</span> -->
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item v-if="checkRightStatus(79)" @click="editZakatAllocation(item)">
                      <v-list-item-title>{{
                        $t("buttons.edit")
                        }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="checkRightStatus(80)" @click="deleteZakatAllocation(item)">
                      <v-list-item-title>{{
                        $t("buttons.delete")
                        }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
            results.</v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import zakatAllocationService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "zakatAllocation-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedZakatAllocation: null,
      headers: [
        {
          text: "Start Date",
          align: "left",
          value: "startDate",
          sortable: true,
        },
        {
          text: 'Parent',
          align: "left",
          value: "Customer.name",
          sortable: true,
        },
        {
          text: 'Student',
          align: "left",
          value: "Student.fullName",
          sortable: true,
        },
        {
          text: "Exp Date",
          value: "endDate",
          align: "left",
          sortable: true,
        },
        {
          text: "Amount",
          value: "amount",
          align: "left",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      zakatAllocations: [],
      search: "",
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    if (this.$route.query && this.$route.query.search) {
      this.search = this.$route.query.search;
    }
    document.title = "taleem - ZakatAllocation";
  },
  components: {
    Create,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["checkRightStatus"]),
    highlightDate() {
      return (date) => {
        if (!date) return "";
        const formattedDate = this.$options.filters.moment(date, "MM/DD/YYYY");

        // Convert search term to regex for partial matching
        const searchQuery = this.search.toLowerCase();
        const regex = new RegExp(searchQuery, "gi");

        if (formattedDate.toLowerCase().includes(searchQuery)) {
          return formattedDate.replace(regex, (match) => `<span class="highlight">${match}</span>`);
        }

        return formattedDate;
      };
    },
    highlightAmount() {
      return (amount) => {
        const formattedAmount = this.$options.filters.currency(amount);
        return this.$options.filters.highlight(formattedAmount, this.search.toLowerCase());
      };
    }
  },
  filters: {
    // highlight(words, query) {
    //   if (query) {
    //     var check = new RegExp(query.toLowerCase(), "ig");
    //     if (words) {
    //       return words.toString().replace(check, function (matchedText) {
    //         return '<span class="highlight">' + matchedText + "</span>";
    //       });
    //     } else {
    //       return words;
    //     }
    //   } else {
    //     return words;
    //   }
    // },
    highlight(text, query) {
      if (!query || !text) return text;

      const searchTerm = query.toLowerCase();
      const textString = text.toString().toLowerCase();

      // Check if the text contains the search term in any form
      if (textString.includes(searchTerm)) {
        return text.replace(new RegExp(searchTerm, "gi"), (match) => {
          return `<span class="highlight">${match}</span>`;
        });
      }

      return text;
    },
  },
  watch: {
    search(val) {
      if (!val) {
        this.search = "";
      }
    },
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;
      return zakatAllocationService.getAll().then((response) => {
        console.log('response zakat', response)
        this.loading = false;
        this.zakatAllocations = response.data;
        return response;
      });
    },
    editZakatAllocation(zakatAllocation) {
      this.selectedZakatAllocation = zakatAllocation;
      this.editDialog = !this.editDialog;
    },
    deleteZakatAllocation(zakatAllocation) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          zakatAllocationService.delete(zakatAllocation.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Zakat Allocation has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
